import { ExternalLink, BarChart2 } from "lucide-react";

interface PowerBiData {
  type?: string;
  title?: string;
  web_url?: string;
  workspace_name?: string;
  rows_pushed?: number | null;
  columns?: unknown[];
}

/**
 * Renders a Power BI embed card from the parsed [POWERBI: {...}] tag.
 */
export default function PowerBiCard({ data }: { data: PowerBiData }) {
  const { title, web_url, workspace_name, type, rows_pushed, columns } = data;

  return (
    <div className="mt-2 inline-flex flex-col gap-1 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm shadow-sm">
      <div className="flex items-center gap-2 font-semibold text-blue-800">
        <BarChart2 size={16} className="shrink-0" />
        <span>{title || "Power BI"}</span>
      </div>

      {workspace_name && (
        <p className="text-xs text-blue-600">Workspace: {workspace_name}</p>
      )}

      {type === "dataset" && rows_pushed != null && (
        <p className="text-xs text-blue-600">
          {rows_pushed} row{rows_pushed !== 1 ? "s" : ""} pushed
          {columns?.length ? ` · ${columns.length} columns` : ""}
        </p>
      )}

      {web_url && (
        <a
          href={web_url}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-1 inline-flex items-center gap-1 rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-blue-700"
        >
          Open in Power BI
          <ExternalLink size={12} />
        </a>
      )}
    </div>
  );
}
